import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {
    FormControl,
    InputLabel,
    OutlinedInput,
    FormHelperText
} from '@mui/material';

function addCommas(nStr) {
    if (!nStr) return '';
    nStr += '';
    var comma = /,/g;
    nStr = nStr.replace(comma, '');
    const x = nStr.split('.');
    let x1 = x[0];
    const x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

function FormInput(props) {
    let {
        label = '',
        path,
        index,
        value = '',
        error = '',
        type = 'text',
        readOnly = false,
        onChange,
        onBlur,
        validator,
        min = -99999,
        mask = '',
        refProp,
        style = {},
        InputProps = {}
    } = props;

    const hasError = !isEmpty(error);

    let extraProps = {};
    if (min !== -99999)
        extraProps = {
            min
        };

    let attributes = {
        error: hasError
    };

    return (
        <React.Fragment>
            <FormControl style={style} sx={{ marginTop: 2 }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">{label}</InputLabel>
                {!mask &&
                    <OutlinedInput
                        value={['decimal', 'currency'].includes(type) ? addCommas(value) : value}
                        onChange={event => {
                            if (readOnly) return;
                            if (!onChange) return;
                            if (['number', 'decimal', 'currency'].includes(type) && event.target.value == '')
                                return onChange(null, path, index);

                            if (type == 'number')
                                return onChange(event.target.value.replace(/[^0-9]/g, ''), path, index);
                            if (type == 'decimal') {
                                let dSplit = event.target.value.split('.');
                                if (dSplit.length == 2 && dSplit[1].length > 2) {
                                    return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                                }
                                return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                            }
                            if (type == 'currency') {
                                let dSplit = event.target.value.split('.');
                                if (dSplit.length == 2 && dSplit[1].length > 2) {
                                    return onChange(value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                                }
                                return onChange(event.target.value.replace(/,/g, '').replace(/[^0-9.]/g, ''), path, index);
                            }
                            onChange(event.target.value, path, index);
                        }}
                        onBlur={event => onBlur && onBlur(event.target.value, path, validator)}
                        {...extraProps}
                        ref={refProp}
                        type={ type ? type :'text'}
                        label={label}
                        {...attributes}
                        variant='standard'
                        inputprops={InputProps}
                    />

                }


                {hasError && <FormHelperText id="outlined-error-helper-text">{error}</FormHelperText>}
            </FormControl>
        </React.Fragment>
    );
}

export default FormInput;
